import { Link } from 'react-router-dom';
import { useSetting } from '@/hooks/useSetting';
import { eventInfo } from '@/mocks/landing-data';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const eventName = useSetting('event_name', eventInfo.name);

  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white">
                {eventName}
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              A premier medical innovation hackathon hosted by Sona College of Technology, Salem in association with the Indian Medical Association (IMA), Salem.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="LinkedIn">
                <i className="ri-linkedin-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200 cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {['About the Event', 'Problem Tracks', 'Register Now', 'FAQ'].map((item) => (
                <li key={item}>
                  <a href={`/#${item.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Resources</h4>
            <ul className="space-y-2.5">
              {['Rule Book', 'Event Brochure', 'Problem Statements', 'Code of Conduct', 'Privacy Policy'].map((item) => (
                <li key={item}>
                  <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <a href="mailto:sonanalamnova2026@sonatech.ac.in" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">
                  sonanalamnova2026@sonatech.ac.in
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">+91 6383586730</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-400">Sona College of Technology, Junction Main Road, Salem – 636005, Tamil Nadu</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {eventName}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">Terms</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">Privacy</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors duration-200 cursor-pointer">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}